import { useEffect, useState } from "react";

// Keep a tiny preview (or the previous slide) visible until the new image decodes.
export default function PreviewImage({ src, preview, srcSet, sizes, alt, fetchPriority = "high", onLoad, ...props }) {
  const [decoded, setDecoded] = useState(null);

  useEffect(() => {
    let active = true;
    const image = new Image();
    image.fetchPriority = fetchPriority;
    image.decoding = "async";
    if (sizes) image.sizes = sizes;
    if (srcSet) image.srcset = srcSet;
    image.src = src;
    image.decode().then(() => {
      if (active) setDecoded({ src, url: image.currentSrc || src });
    }).catch(() => {
      // Retain the preview/last good frame on a failed request.
    });
    return () => { active = false; };
  }, [src, srcSet, sizes, fetchPriority]);

  return (
    <img
      {...props}
      alt={alt}
      src={decoded?.url || preview}
      srcSet={decoded?.src === src ? srcSet : undefined}
      sizes={sizes}
      fetchpriority={fetchPriority}
      loading="eager"
      decoding="async"
      onLoad={decoded?.src === src ? onLoad : undefined}
    />
  );
}
